import axios, {AxiosResponse} from 'axios'
import {UserReportsQueryResponse} from './_models'
import Swal from 'sweetalert2'

const API_URL = process.env.REACT_APP_API_URL + '/api'
const REPORTS_URL = `${API_URL}/kpi/reports`

const getUserReports = (query: string): Promise<UserReportsQueryResponse> => {
  return axios
    .get(`${REPORTS_URL}/sales-by-day?${query}`)
    .then((d: AxiosResponse<UserReportsQueryResponse>) => d.data)
}
export {getUserReports}
